import styles from "../Startup/Choose.module.css";
import { Logo, ToastContainer, BiCheck, RiDragMove2Line } from '../../common/common'
import MidReorderProductAttributes from "../../middleware/Seller/Details/MidReorderProductAttributes";
import useNavigation from "../../common/useNavigation";
import ExporttoExcel from "./ExporttoExcel";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
const ReOrderProdcutattributes = () => {
    const { navigateDashboard } = useNavigation();
    const { handleDragEnd, getattributes, handleShowProductAttributes, isattributesShow } = MidReorderProductAttributes();
    return (
        <div>
            <div className={`${styles.personalDetails} hidden lg:block lg:w-[30%] fixed h-screen overflow-y-auto scrollbar-hide `} >
                <div className="h-[100px]">
                    <div className="flex flex-row justify-center">
                        <img className="mr-0" src={Logo} width={160} height={70} alt="Dasahboard" />
                    </div>
                </div>
                <div className="mt-32">
                    <div className='relative mx-10  rounded-xl bg-[#006e65]'>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>
                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-60  rounded-md py-1">
                                    <h1 className="text-xl font-semibold text-white">
                                        Seller Profile Configuration
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        To establish your seller profile, please complete the designated form. You may create multiple seller profiles under the same Selzor account; however, a separate plan is required for each seller profile.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#07ff5a] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12">

                                    <span className="text-xl sm:text-2xl px-2">
                                        <BiCheck className="text-2xl" />
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-60  rounded-md py-1">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "} Product Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Select mandatory attributes (code, name, category) and choose which to display to customers while adding product data{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className={`${styles.animationPulse} bg-[#ffc107] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 sm:w-12 sm:h-12`}>

                                    <span className="text-xl sm:text-2xl px-2">
                                        3
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto ">
                                    <h1 className="text-xl font-semibold text-white">
                                        {" "} Reorder Attributes {" "}
                                    </h1>
                                    <p className="text-sm font-medium text-white">
                                        {" "}Streamline product attributes to enhance clarity and facilitate informed decision-making{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="block">
                            <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                                {/* BiCheck Icon Container */}
                                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                                    <span className="text-xl sm:text-2xl px-2">
                                        4
                                    </span>
                                </div>

                                {/* Text Content */}
                                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                                    <h1 className="text-xl font-semibold text-[#a0a0a0]">
                                        {" "}Import Product Excelsheet{" "}
                                    </h1>
                                    <p className="text-sm font-medium text-[#a0a0a0]">
                                        {" "}Easily import product information using the Excel spreadsheet to manage your inventory better{" "}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" grid grid-cols-1 lg:col-span-8 lg:ml-[30%] ">
                <div className="text-center text-blue-700 lg:hidden">
                    <div className="lg:max-w-[400px] w-full my-2 mx-auto p-2 flex flex-row">
                        <img src={Logo} width={160} height={70} alt="selzor Logo" />
                    </div>
                </div>
                <div className="max-w-full bg-white pb-10 mb-24 px-3 ">
                    <div className=" p-3 rounded-xl my-2 bg-[#ddfdfa]">
                        <h1 className="text-lg text-[#0cb1a3] font-bold"> Product Attributes </h1>
                        <p className="text-[#414747] text-sm font-medium"> select attributes as per your products range, code, name and category are required attributes. you have to an option to include all attributes while adding product data but displaying only few of them to your buyers.</p>
                    </div>

                    {!isattributesShow ?
                        <div className="flex  justify-center bg-gray-100">
                            {/* <img src={bgDirection} alt="" /> */}
                            <div className="flex flex-col items-center  p-2 rounded-xl my-2 bg-[#e3f1ff] mx-2">
                                <p className="text-[#414747] text-sm font-medium text-center">Seamlessly upload multiple products at once by importing an Excel sheet. Ensure your data includes essential attributes like product code, name, and category for each item. You can also include additional attributes in your Excel file; however, only the selected ones will be displayed to your customers on the platform.</p>
                                <div className="flex space-x-4 mt-4">
                                    <button className="relative p-2 text-center rounded-md  items-center bg-[#0bb29f] hover:bg-[#1e7067]" onClick={() => navigateDashboard('seller')}>
                                        <span className="relative text-sm text-center font-semibold text-white">Continue to Dashboard</span>
                                    </button>
                                    <button className="relative p-2 text-center rounded-md  items-center bg-[#0bb29f] hover:bg-[#1e7067]" onClick={handleShowProductAttributes}>
                                        <span className="relative text-sm text-center font-semibold text-white w-full px-2">Bulk Products Upload via Excel Sheet</span>
                                    </button>
                                </div>
                            </div>
                        </div> : null}


                    {isattributesShow ? <div className=" mt-3 p-4 overflow-scroll  border-2 rounded-xl border-[#e5e5e5]">
                        <div className="flex justify-end">
                            <div className="flex flex-row">
                                <ExporttoExcel userDetails={getattributes} />
                                <button className="relative group  rounded-md  items-center bg-[#0bb29f] hover:bg-[#0bb29f] w-full px-2 mx-2" onClick={() => navigateDashboard('seller')} >
                                    <span className="relative text-sm text-white font-semibold"> Skip Bulk Product Upload </span>
                                </button>
                            </div>
                        </div>
                        <DragDropContext onDragEnd={(result) => handleDragEnd(result)}>
                            <table className="table-auto border-separate border-spacing-y-4">
                                <thead>
                                    <tr>
                                        <th className="text-2xl text-[#053f7a] w-[2%] py-5 pl-4 text-center">
                                            <RiDragMove2Line />
                                        </th>
                                        <th className="text-md text-[#053f7a] w-1/5 px-5 py-5 text-center">
                                            Product Attributes{" "}
                                        </th>
                                        {/* <th className='text-md text-[#673AB7] w-1/5 px-2 py-5 text-left'>Custom Attributes Name </th> */}
                                        <th className="text-md text-[#053f7a] w-1/5 px-5 py-5 text-center">
                                            Max Characters{" "}
                                        </th>
                                        <th className="text-md text-[#053f7a] w-1/5 px-5 py-5 text-center">
                                            Cell Format{" "}
                                        </th>
                                        {/* <th className="text-md text-[#673AB7] w-1/5 px-5 py-5 text-center">
                        Action{" "}
                      </th> */}
                                    </tr>
                                </thead>
                                <Droppable droppableId="tbody">
                                    {(provided) => (
                                        <tbody
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                        >
                                            {getattributes?.map((user, index) => (
                                                <Draggable
                                                    draggableId={user.attributeName}
                                                    key={user.id}
                                                    index={index}
                                                >
                                                    {/*                                     {user.id}{" "} */}
                                                    {/*                                 className="  mb-0 text-[#673AB7] py-5 pl-2 text-center border-[1px] border-solid border-gray-100 bg-slate-50 rounded-xl shadow-sm" */}
                                                    {(provided, snapshot) => (
                                                        <tr
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={`${styles.tableRow} ${snapshot.isDragging ? styles.dragging : ""}`}
                                                            style={{
                                                                ...provided.draggableProps.style,
                                                                background: snapshot.isDragging ? "#e5e5e5" : "white", // Example background color
                                                                // border: snapshot.isDragging ? "1px solid #e5e5e5" : "1px solid #e5e5e5",
                                                                padding: "0px", // Maintain padding during drag
                                                                margin: "10px 0", // Maintain margin during drag
                                                                boxSizing: "border-box", // Ensure padding is included in width/height calculations
                                                            }}
                                                        >
                                                            <td className={`${snapshot.isDragging ? "border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center" : "border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center"}`}>
                                                                <div className="text-lg font-semibold text-[#673AB7]">
                                                                    <RiDragMove2Line />
                                                                </div>
                                                            </td>
                                                            <td className={`${snapshot.isDragging ? " w-1/4 border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center" : "border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center"}`}>
                                                                {user.attributeName}
                                                            </td>

                                                            <td className={`${snapshot.isDragging ? "w-1/4 border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center" : "border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center"}`} >50</td>
                                                            <td className={`${snapshot.isDragging ? "w-1/4 border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center" : "border-border-color  relative p-2  py-2 mx-2   rounded-md mt-1 border-[1px]  text-center"}`} >Text</td>

                                                        </tr>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </tbody>
                                    )}
                                </Droppable>
                            </table>
                        </DragDropContext>
                    </div> : null}

                    <ToastContainer />
                </div>
            </div>
        </div>
    )
}

export default ReOrderProdcutattributes